/**
 * Enables debugging on local, dev, and test environments
 */
if ( ['local', 'dev', 'test'].includes(window.APP_ENV) ) {
    console.info('DEBUG ENABLED');
    console.debug = window.console.log.bind(window.console.debug, 'DEBUG:: %s');
} else {
    console.debug = function () { }
}
